import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { spacing } from '@metro-ui/tokens/js';
import { Manager, Popper, Reference } from 'react-popper';
import { CSSTransition } from 'react-transition-group';
import { rem2pixelNumber } from '../utils/rem2pixels';
import { Popover, animationClass, } from './components/Popover';
var enrichHandlerWith = function (enrichF) { return function (handler) {
    if (typeof handler === 'function') {
        return function (event) {
            enrichF();
            handler(event);
        };
    }
    return enrichF;
}; };
export var Tooltip = styled(/** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { visible: false };
        _this.showTooltip = enrichHandlerWith(function () {
            _this.setState({ visible: true });
        });
        _this.hideTooltip = enrichHandlerWith(function () {
            _this.setState({ visible: false });
        });
        _this.getEvents = function (element) {
            return {
                onMouseEnter: _this.showTooltip(element.props.onMouseEnter),
                onMouseLeave: _this.hideTooltip(element.props.onMouseLeave),
                onFocus: _this.showTooltip(element.props.onFocus),
                onBlur: _this.hideTooltip(element.props.onBlur),
            };
        };
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, description = _a.description, _b = _a.position, position = _b === void 0 ? 'top' : _b, hasFixedPosition = _a.hasFixedPosition, _c = _a.isAlwaysVisible, isAlwaysVisible = _c === void 0 ? false : _c, _d = _a.forwardRefAs, forwardRefAs = _d === void 0 ? 'ref' : _d, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["id", "description", "position", "hasFixedPosition", "isAlwaysVisible", "forwardRefAs", "className", "children"]);
        var visible = this.state.visible;
        var shouldDisplay = isAlwaysVisible || visible;
        var onlyChild = React.Children.only(children);
        return (React.createElement(Manager, null,
            React.createElement(Reference, null, function (_a) {
                var _b;
                var ref = _a.ref;
                return onlyChild &&
                    React.cloneElement(onlyChild, __assign((_b = {}, _b[forwardRefAs] = ref, _b['aria-describedby'] = id, _b), _this.getEvents(onlyChild)));
            }),
            React.createElement(CSSTransition, { appear: true, mountOnEnter: true, unmountOnExit: true, classNames: animationClass, timeout: 800, in: shouldDisplay },
                React.createElement(Popper, { placement: position, modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, rem2pixelNumber(spacing['x-small'])],
                            },
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                rootBoundary: 'viewport',
                                altAxis: true,
                            },
                        },
                    ], strategy: hasFixedPosition ? 'fixed' : undefined }, function (_a) {
                    var ref = _a.ref, style = _a.style, placement = _a.placement, arrowProps = _a.arrowProps;
                    return (React.createElement(Popover, __assign({}, htmlAttributes, { id: id, ref: ref, role: "tooltip", style: style, placement: placement, arrowProps: arrowProps, className: className }), description));
                }))));
    };
    return Tooltip;
}(React.Component)))(function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""]))); });
Tooltip.propTypes = {
    id: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    position: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
    hasFixedPosition: PropTypes.bool,
    isAlwaysVisible: PropTypes.bool,
    forwardRefAs: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
};
var templateObject_1;
//# sourceMappingURL=Tooltip.js.map